(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	require('toggle-hash');

	$('[data-toggle-hash], #header a[href="#header-search"]').toggleHash();
})();
